export const PRICING_MODEL_SUBSCRIPTION = 'subscription';
export const PRICING_MODEL_COMMISSION = 'commission';

/**
 * Case-insensitive check for whether the given pricing model value is the
 * commission model. Only used for comparison - never mutates/re-saves the
 * stored value, which may still be saved with mixed casing (e.g. 'Commission').
 */
export const isCommissionPricingModel = pricingModel =>
  typeof pricingModel === 'string' && pricingModel.toLowerCase() === PRICING_MODEL_COMMISSION;

/**
 * Returns the customer commission percentage (e.g. 10 for 10%) from hosted
 * config (transactions/commission.json), or null if it's not set.
 */
export const getCustomerCommissionPercentage = config => {
  const percentage = config?.commission?.customerCommission?.percentage;
  return typeof percentage === 'number' ? percentage : null;
};

// The provider user type ("verhuurder") gets the subscription pricing model at signup.
export const PROVIDER_USER_TYPE = 'Verhuurder';

/**
 * Public data set on every new user at signup:
 * - profileShow: the user's profile (name/avatar) is shown on listing pages and the order panel
 * - pricingModel: providers start on the subscription pricing model
 */
export const getSignupPublicData = userType => ({
  profileShow: true,
  ...(userType === PROVIDER_USER_TYPE ? { pricingModel: PRICING_MODEL_SUBSCRIPTION } : {}),
});
